var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 203,
    viewBox: "0 0 203 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 101.5,
    cy: 101.5,
    r: 101.5,
    fill: "url(#paint0_linear_231_3)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152 108.42C152 90.7832 152 63.332 152 54.3317C152 47.2674 139.594 38.4744 128.405 38.0108C119.308 37.6338 107 47.2674 107 47.2674V67.973C107 67.973 117.014 77.7909 125.243 78.9348C130.647 79.6859 139.108 77.2297 139.108 77.2297V108.42M152 108.42C152 117.515 152 124 152 124H139.108V108.42M152 108.42H139.108M116.375 52.3333V64.1739",
    stroke: "#F1F4F6",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 142.783C48 125.556 48 98.7429 48 89.9519C48 83.0519 60.1299 74.4633 71.0703 74.0105C79.9657 73.6424 92 83.0519 92 83.0519V103.276C92 103.276 82.2088 112.865 74.1622 113.983C68.8788 114.717 60.6054 112.317 60.6054 112.317V142.783M48 142.783C48 151.666 48 158 48 158H60.6054V142.783M48 142.783H60.6054M82.8333 88V99.5652",
    stroke: "#F1F4F6",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_231_3",
    x1: 54,
    y1: 48,
    x2: 134,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FA2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB1BD",
    stopOpacity: 0.97
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup24);
export default __webpack_public_path__ + "static/media/Group 24.6450933c35849e2b476dfd6217b45105.svg";
export { ForwardRef as ReactComponent };